












































































































































import {
	Component,
	Vue,
	Prop,
	Watch,
	Inject,
	Mixins
} from "vue-property-decorator";
import {
	ParticaConfirmConfig
} from "../../Models/Components.model";
import {
	ContentStreamIssueDTO,
	IssueModel,
	ArticleModel,
	ListItemDTO,
	AddArticleContentStreamDTO,
	ContentStreamBillingConfigurationClient,
	ContentStreamBillingConfigurationDTO,
	ContentStreamDTO,
	ContentStreamDTOStatus,
	CustomerArticleLicenceDTO
} from "../../Generated/ParticaAPI";

import ArticleListXl from "@/Ui-Components/Article/ArticleListXl.vue";
import SearchArticles from "@/Views/Articles/SearchStoreArticles.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaConfirmDialog from "@/Ui-Components/Common/ConfirmDialog/ParticaConfirmDialog.vue";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardMax from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import ParticaArticleCurate from "@/Ui-Components/Article/Curate/ParticaArticleCurate.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaStreamBase from "../Base/ParticaStreamBase.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";


import { NavigationService } from "../../NavigationServices/navigation";
import { ContentStreamIssueService, IContentStreamIssueService } from "../../BusinessServices/contentstreamissue";
import { ContentStreamCurateService, IContentStreamCurateService } from "../../BusinessServices/contentstreamcurate";
import { ContentStreamService, IContentStreamService } from "../../BusinessServices/contentstream";
import { Article, IArticle, ICuratedArticle } from "../../Models/ArticleModels/article";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonStatus, ButtonType } from "../../Models/Buttons";
import { BreadcrumbItem } from "../../Models/Breadcrumb";
import ParticaDate from "../../Ui-Components/Common/Date/ParticaDate.vue";
import { IIssueService } from "../../BusinessServices/issue";
import { IParticaStoreService } from "../../BusinessServices/particastore";

@Component({
	name: "ContentStreamIssue",
	components: {
		SearchArticles,
		ButtonList, ParticaError, ParticaConfirmDialog, ParticaArticlePreview,
		ParticaRowContainer, ParticaColumnContainer, ParticaArticleCurate, ParticaCard,
		ArticleListXl, ParticaView, ParticaRightDrawer,
		ParticaDate, ParticaCardMax
	}
})
export default class ContentStreamIssue extends ParticaStreamBase {
	@Prop() private id: number;
	@Prop() private issueid: number;
	private contentStreamIssueService: IContentStreamIssueService;
	private issueService: IIssueService;
	private contentStreamService: IContentStreamService;
	private contentStreamCurateService: IContentStreamCurateService;
	private article: ICuratedArticle = new Article() as ICuratedArticle;
	private previewarticle: IArticle = new Article();
	private showpreviewbuttons: boolean = false;
	private showcuratearticle: boolean = false;
	private billingSettings: ContentStreamBillingConfigurationDTO = new ContentStreamBillingConfigurationDTO();
	private showSearch: boolean = false;
	private stream: ContentStreamDTO = new ContentStreamDTO();
	private showlicence: boolean = false;
	private licence: CustomerArticleLicenceDTO = new CustomerArticleLicenceDTO();
	private storeService: IParticaStoreService;

	private finalizeDialog = {
		title: "Confirm Finalization.",
		message: "Are you sure you want to finalize this issue? You cannot alter the issue once finalized.",
		show: false
	} as ParticaConfirmConfig;

	private addArticleToIssueDialog = {
		title: "Confirm adding article to stream.",
		message: `Adding the article to the stream will entitle the article owner to a percentage of the stream price.`,
		show: false
	} as ParticaConfirmConfig;


	private datebutton: ButtonConfig[] = [
		{
			label: "",
			action: eParticaAction.ISSUE_DATE_SAVE,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled,
			icon: "save"
		} as ButtonConfig
	];

	private showeditarticle: boolean = false;
	private showpreviewarticle: boolean = false;

	private articles: IArticle[] = [];
	private issue: IssueModel = new IssueModel();
	private articleactions: ButtonConfig[] = [
		// init our menu for the list.
		{
			label: "View",
			action: eParticaAction.ARTICLE_PREVIEW,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Edit",
			action: eParticaAction.ARTICLE_EDIT,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Remove",
			action: eParticaAction.CONTENT_STREAM_REMOVE_ARTICLE_ISSUE,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Licence",
			action: eParticaAction.CONTENT_STREAM_ARTICLE_LICENCE,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig
	];

	private buttons: ButtonConfig[] = [
		{
			label: "Finalize",
			action: eParticaAction.CONTENT_STREAM_FINALIZE_ISSUE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Delete",
			action: eParticaAction.ISSUE_DELETE,
			type: ButtonType.Cancel,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Search",
			action: eParticaAction.ARTICLE_SHOW_SEARCH,
			type: ButtonType.Normal,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private editarticlebuttons: ButtonConfig[] = [
		{
			label: "Save Article",
			action: eParticaAction.ARTICLE_SAVE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	private previewbuttons: ButtonConfig[] = [
		{
			label: "Add to stream",
			action: eParticaAction.CONTENT_STREAM_ADD_ARTICLE_ISSUE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];


	private async finalizeIssue() {
		try {
			this.LoadingStart();
			this.finalizeDialog.show = false;
			await this.contentStreamIssueService.finalizeIssue(this.issueid);
			await this.init();
			this.ShowSnackbar("The issue has been finalized. Go to your todo list to curate articles.");
		} catch (error) {
			this.ShowErrorDialog(error, "An error occured finalizing the issue. Contact support.");
		} finally {
			this.LoadingEnd();
		}
	}

	private async articleSelected(selectedarticle: IArticle) {
		try {
			this.LoadingStart();
			this.showpreviewbuttons = true;
			this.previewarticle = selectedarticle;
			this.showpreviewarticle = true;
		} catch (error) {
			this.ShowErrorDialog(
				error,
				`An error occured previewing the article (${selectedarticle.title})`
			);
		} finally {
			this.LoadingEnd();
		}

	}

	private async addArticleToIssue(articleId: string) {
		try {
			this.LoadingStart();
			const found = this.articles.find(a => a.parentArticleId === articleId);
			if (found !== undefined) {
				this.ShowSnackbar("Unable to add article as it has already been added.");
			} else {
				const obj: AddArticleContentStreamDTO = new AddArticleContentStreamDTO();
				obj.articleId = articleId;
				obj.contentStreamIssueId = this.issueid;
				await this.contentStreamIssueService.addArticleToContentStream(obj);
				this.showpreviewarticle = false;
				await this.init();
			}
		} catch (error) {
			this.ShowErrorDialog(
				error,
				`An error occured adding the article (${articleId})`
			);
		} finally {
			this.addArticleToIssueDialog.show = false;
			this.LoadingEnd();
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_ADD_ARTICLE_ISSUE: {
					this.articles.forEach(article => {
						if (article.parentArticleId === this.previewarticle.parentArticleId) {
							this.ShowSnackbar("This article has already been added to the issue.");
							return;
						}
					});
					const remaining: number = this.getArticleLimitRemaining();
					if (remaining < (this.previewarticle.price / 100) && this.stream.status === ContentStreamDTOStatus.Active) {
						// tslint:disable-next-line
						this.ShowSnackbar(`You cannot add this article to the issue as it costs $${this.previewarticle.price / 100}. You have $${remaining} remaining.`);
					} else {
						this.addArticleToIssueDialog.show = true;
					}
					break;
				}
				case eParticaAction.ARTICLE_PREVIEW: {
					this.previewarticle = await this.contentStreamCurateService.getArticleForCuration(event.item.id as string) as IArticle;
					this.showpreviewbuttons = false;
					this.showpreviewarticle = true;
					break;
				}
				case eParticaAction.ARTICLE_SHOW_SEARCH: {
					this.showSearch = true;
					break;
				}
				case eParticaAction.ARTICLE_EDIT: {
					if (this.issue.status === 1) { // ContentStreamIssueStatus.Finalised
						this.ShowSnackbar("You cannot edit an article in a finalized issue.");
					} else {
						this.article = await this.contentStreamCurateService.getArticleForCuration(event.item.id as string);
						this.showcuratearticle = true;
					}
					break;
				}
				case eParticaAction.CONTENT_STREAM_REMOVE_ARTICLE_ISSUE: {
					if (this.issue.status === 1) { // ContentStreamIssueStatus.Finalised
						this.ShowSnackbar("You cannot remove an article in a finalized issue.");
					} else {
						await this.contentStreamIssueService.RemoveArticleFromIssue(event.item.id as string);
						this.ShowSnackbar(`Article removed.`);
						await this.init();
					}
					break;
				}
				case eParticaAction.CONTENT_STREAM_FINALIZE_ISSUE: {
					if (this.articles.length === 0) {
						this.ShowSnackbar("You cannot finalize an issue with no articles. Add some articles.");
					} else {
						this.finalizeDialog.show = true;
					}
					break;
				}
				case eParticaAction.CONTENT_STREAM_ARTICLE_LICENCE: {
					this.licence = await this.storeService.getArticleLicence(event.item.id as string);
					this.showlicence = true;
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					await this.contentStreamCurateService.SaveSourceArticle(this.article);
					this.ShowSnackbar(`'${this.article.title}' saved.`);
					await this.init();
					break;
				}
				case eParticaAction.PROPERTY_CHANGED: {
					break;
				}
				case eParticaAction.ISSUE_DATE_SAVE: {
					this.issue = await this.issueService.UpdateIssueDate(this.issue);
					this.ShowSnackbar("Issue date has been updated.");
					break;
				}
				case eParticaAction.ISSUE_DELETE: {
					if (this.articles.length > 0) {
						this.ShowSnackbar("You cannot delete an issue with articles. You must remove the articles first.");
						break;
					} else {
						await this.contentStreamIssueService.DeleteIssue(this.issueid);
						this.ShowSnackbar("Issue deleted.");
						this.$router.push({ path: `/contentstream/${this.id}/` });
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured handling event ${event.action}`
			);
		} finally {
			this.LoadingEnd();
		}
	}

	private getArticleLimitRemaining(): number {
		let value: number = 0;
		if (this.articles.length > 0) {
			this.articles.forEach(a => {
				value += (a.price / 100 as number);
			});
		}
		return this.billingSettings.maximumValueContent - value;
	}

	private async init() {
		try {
			this.LoadingStart();
			this.issue = await this.contentStreamIssueService.getIssue(this.issueid);
			this.billingSettings = await this.contentStreamService.getContentStreamBillingConfig(this.id);
			this.stream = await this.contentStreamService.getContentStream(this.id);
			if (this.issue.status === 1) { // ContentStreamIssueStatus.Finalised
				this.SetButtonStatus(this.buttons, eParticaAction.CONTENT_STREAM_FINALIZE_ISSUE, ButtonStatus.Disabled);
				this.SetButtonStatus(this.buttons, eParticaAction.ISSUE_DELETE, ButtonStatus.Disabled);
				this.SetButtonStatus(this.buttons, eParticaAction.ARTICLE_SHOW_SEARCH, ButtonStatus.Disabled);
				// remove actions
				this.SetButtonStatus(this.articleactions, eParticaAction.ARTICLE_EDIT, ButtonStatus.Disabled);
				this.SetButtonStatus(this.articleactions, eParticaAction.CONTENT_STREAM_REMOVE_ARTICLE_ISSUE, ButtonStatus.Disabled);
			}
			this.navigationService = new NavigationService();
			this.articles = await this.contentStreamIssueService.GetArticlesForIssue(this.issueid);
			await this.getStreamNav(this.id);
			this.breadcrumbs.splice(3, 0, {
				text: this.issue.name,
				to: `/contentstream/${this.id}/issue/${this.issueid}/`,
				exact: true,
				disabled: false
			} as BreadcrumbItem);
		} catch (e) {
			this.ShowErrorDialog(e, `An error occured loading the issue.`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Stream issue";
		this.storeService = this.particaServices.getParticaStoreService();
		this.contentStreamIssueService = this.particaServices.getContentStreamIssueService();
		this.contentStreamCurateService = this.particaServices.getContentStreamCurateService();
		this.issueService = this.particaServices.getIssueService();
		this.contentStreamService = this.particaServices.getContentStreamService();
		await this.init();

	}
}
